import {param, deparam} from 'nutshell-core/routing/query-parameters';

export const updateSearchWithNewFilter = (
    filterKey: string,
    entityId: string,
    search: string,
    validFilterKeys: string[]
) => {
    // if the passed filterKey is not valid, return the search string
    if (!validFilterKeys.includes(filterKey)) {
        return search;
    }

    // remove ? before search string
    let newSearch = search.slice(1);

    // convert search string to object
    newSearch = deparam(search);

    // change only the filter portion of the search string
    // @ts-expect-error
    const searchFilter = newSearch.filter;

    // get an array of the existing filter keys in the searchFilter
    const filterKeysInSearch = Object.keys(searchFilter);

    // remove all existing filters from searchFilter, preserving 'period'
    filterKeysInSearch
        .filter((key) => key !== 'period')
        .forEach((key) => {
            delete searchFilter[key];
        });

    // set the passed filterKey to editionId
    searchFilter[filterKey] = [entityId];

    // assign newSearch the modified filter
    // @ts-expect-error
    newSearch.filter = searchFilter;

    // convert newSearch object to string
    newSearch = param(newSearch);

    return newSearch;
};
